import React, { Component } from 'react';
import { connect } from 'react-redux';
import ClickOutside from '../ClickOutside';
import './SelectList.scss';

const mapStateToProps = (state) => {
    return {
        device: state.device.current
    }
}

class SelectList extends Component {
    static defaultProps = {
        theme : 'green',
        fieldName : 'name',
    }

    constructor(props){
        super(props);
        this.container = React.createRef();
    }

    state={
        showSpinner:false
    }
    toogle=()=>{
        this.setState({showSpinner:!this.state.showSpinner, spinnerPosition : 'bottom'});
        // let rect = this.container.current.getBoundingClientRect();
        // let windowHeight = window.document.body.clientHeight;
        // if(windowHeight - rect.bottom > rem2px(this.props.list.length * 0.4)){
        //     this.setState({showSpinner:!this.state.showSpinner, spinnerPosition : 'bottom'});
        // }else{
        //     this.setState({showSpinner:!this.state.showSpinner, spinnerPosition : 'top'});
        // }
    }

    onItemSelected=(v)=>{
        this.setState({showSpinner:false});
        this.props.onItemSelected(v);
    }

    render(){
        const { showSpinner, spinnerPosition } = this.state;
        const { device, value, list, fieldName } = this.props;
        let pc = device === 'pc';
        return <ClickOutside onClickOutside={()=>this.setState({showSpinner:false})} style={{flex: 1}}>
            <div className='select_list_container' ref={this.container} style={this.props.style}>
                <div className={pc ? 'select_list_value_pc' : 'select_list_value'} onClick={this.toogle}>
                    <div className='select_list_value_text'>{value}</div>
                    <img alt='' className='select_list_value_arrow' 
                        src={require('./assets/arrow_down.png')}
                        style={{transform:`rotate(${showSpinner ? '180deg': '0deg'})`}}></img>
                </div>
                {
                    showSpinner&&<div className="login_select_list_panel" style={{
                        top: spinnerPosition === 'bottom' ? ( pc ? '.88rem' : '.64rem') : -(list.length * (pc ? 0.8 : 0.6) + 0.08)+'rem'
                    }}>
                        {
                            list && list.map((v, i, a)=>{
                                return <div key={i} 
                                    className={pc ? 'login_select_list_item_pc' : 'login_select_list_item' }
                                    onClick={this.onItemSelected.bind(this, v)}>
                                    <div className='select_list_item_text'>{v[fieldName]}{v[fieldName] === value && ' ✓'}</div>
                                </div>
                            })
                        }
                    </div>
                }
            </div>
        </ClickOutside>
    }
}

export default connect(mapStateToProps)(SelectList);